import React from "react";

function SvgTicketIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
      {...props}
    >
      <g transform="rotate(-45, 12, 12)">
        {/* Ticket body */}
        <rect x="3" y="8" width="18" height="8" rx="1" ry="1" fill="none" stroke="currentColor" strokeWidth="1.2" />
        {/* Left notch */}
        <circle cx="3" cy="12" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
        {/* Right notch */}
        <circle cx="21" cy="12" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
        {/* Perforation line */}
        <line x1="9" y1="8" x2="9" y2="16" stroke="currentColor" strokeWidth="0.8" strokeDasharray="1.5,1" />
        {/* Stub lines */}
        <line x1="11" y1="10.5" x2="18" y2="10.5" stroke="currentColor" strokeWidth="0.8" />
        <line x1="11" y1="12" x2="18" y2="12" stroke="currentColor" strokeWidth="0.8" />
        <line x1="11" y1="13.5" x2="16" y2="13.5" stroke="currentColor" strokeWidth="0.8" />
      </g>
    </svg>
  );
}

export default SvgTicketIcon;
